export default "__VITE_ASSET__BHhdpm05__"